module.exports = __webpack_public_path__ + "media/images/niq-close-8175b1f92788a04656a9f39f769d3a34.svg";